export default __webpack_public_path__ + "static/media/Fireguard Mantle.f067e4da.jpg";